import React, { Fragment, useMemo } from 'react';
import { useSubscribe } from '@core/utils/hooks/rxjs';
import { createHistory, HistoryProvider } from '@core/router';
import { ModalStack } from '@core/components/ModalStack';
import { Session } from '@modules/auth/session';
import { initBlocs, resetBlocs } from '@business/blocs';
import { AppRouter } from './AppRouter';
import '@styles/theme.scss';
import './index.scss';
import { AppConfig } from '@core/utils/config';
import { Endpoint } from '@business/api/endpoint';
import { LoadingBar } from '@core/components/LoadingBar';
import ErrorBoundary from './ErrorBoundary';
import { PageContext } from '@core/components/PageContext';
import { PageFocusProvider } from '@core/components/PageFocusProvider';
import SimpleReactLightbox from 'simple-react-lightbox';
import { AppContextProvider } from '@core/components/AppContextProvider';
import 'spectrum-colorpicker2/src/spectrum.css';

export default function App() {
  const history = useMemo(() => createHistory(), []);

  useSubscribe(Session.sessionStart$, url => {
    initBlocs();
    if (url) {
      history.replace(url);
    } else {
      history.replace('/');
    }
  });

  useSubscribe(Session.sessionEnd$, () => {
    history.replace('/login');
    resetBlocs();
  });

  AppConfig.get();

  useSubscribe(AppConfig.changed$, config => {
    Endpoint.setCompanyId(config.companyId);
  });

  return (
    <Fragment>
      {/* <Global styles={GlobalStyles} /> */}

      <HistoryProvider history={history}>
        <ErrorBoundary>
          <AppContextProvider>
            <PageFocusProvider>
              <LoadingBar>
                <PageContext>
                  <SimpleReactLightbox>
                    <AppRouter />
                    <ModalStack />
                  </SimpleReactLightbox>
                </PageContext>
              </LoadingBar>
            </PageFocusProvider>
          </AppContextProvider>
        </ErrorBoundary>
      </HistoryProvider>
    </Fragment>
  );
}
